/** Maps recognized Aqualia hostnames to the backend server hostname used by the interceptor. */
export const AQUALIA_ROUTES = [
  { url: "ia.iotwater.es", server: "srvia.iotwater.es" },
  { url: "aquacity.arsondata.com", server: "aquacitysrv.arsondata.com" },
  // { url: "aqualia.arsondata.com", server: "aqualiasrv.arsondata.com" },
  { url: "aqualia.arsondata.com", server: "lorawansrv.aqualiametering.com" },
  {
    url: "lorawan.aqualiametering.com",
    server: "lorawansrv.aqualiametering.com",
  },
  {
    url: "sefo.aqualiametering.com",
    server: "lorawansrv.aqualiametering.com",
  },
];
